import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import PlaceholderImage from "./PlaceholderImage";
import PinchZoomPan from "react-responsive-pinch-zoom-pan";
import Carousel from "react-bootstrap/Carousel";
import { displayTranslations, isPresent } from "../../utils/utils";

const ShowLargeImageModal = ({
   blueprintImage,
   showZoomImg,
   setShowZoomImg,
   hidePlaceHolderText,
   imgType,
   renderCarouselImageIndex,
   setRenderCarouselImageIndex,
   carouselImageType,
   position
  }) => {

  const [index, setIndex] = useState(renderCarouselImageIndex);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
    setRenderCarouselImageIndex(selectedIndex)
  };

  useEffect(() => {
    setIndex(renderCarouselImageIndex);
    if (showZoomImg){
      $('html, body').css('overflowY', 'hidden');
    }else{
      $('html, body').css('overflowY', '');
    }
  }, [showZoomImg]);


  const imgToRender =
    !isPresent(renderCarouselImageIndex) ?
      blueprintImage[`xx_large_${imgType ? imgType + '_' : ''}image_url`] :
        blueprintImage['xx_large_carousel_images_urls'][renderCarouselImageIndex][`xx_large_${carouselImageType[renderCarouselImageIndex]}_url`]
  
  const handleCloseZoomImage = () => {
    setShowZoomImg(false)
  }

  const blueprintImageNames = displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language)
  
  return <Modal id={'view-image-modal'} show={showZoomImg} onHide={handleCloseZoomImage} animation={false} size="lg">
    <Modal.Header closeButton>
      <Modal.Title className="mt-1">
        {
          blueprintImageNames.length > 1 ?
            blueprintImageNames[0] + ' (' +
            blueprintImageNames[1] + ')'
          :
            blueprintImageNames[0]
        }
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="d-flex justify-content-center text-center w-100 p-0">
        {
          imgToRender && imgToRender.toString().toLowerCase().indexOf('placeholder') === -1 ?
            <div>
              {!carouselImageType || (carouselImageType && blueprintImage.xx_large_carousel_images_urls === null) ?
                <div className={`${!position ? 'box-img-show-large-modal' : 'box-img-show-large-modal-2'}`}>
                  <PinchZoomPan zoomButtons={false} maxScale={10} position={position ? position : 'center'}>
                    <img
                      alt=""
                      src={imgToRender}
                    />
                  </PinchZoomPan>
                </div>
              :

                <Carousel id={'carousel-img'} className="w-100" activeIndex={index} onSelect={handleSelect} >
                  {
                    blueprintImage['xx_large_carousel_images_urls'].map((row,i)=>
                      <Carousel.Item key={'carousel_'+ i } interval={100000} >
                        <div className="w-100">
                          {/*<div id="carousel-box"
                            style={{ height: '651px', width: '60%', marginLeft: '20%', marginRight: '20%'}}>*/}
                          <div className={`${!position ? 'box-img-show-large-modal' : 'box-img-show-large-modal-2'}`}>
                            <div style={{width: '80%', height: '90%', margin: 'auto', paddingTop: '5%'}}>
                              <PinchZoomPan id="zoom-box" zoomButtons={false} maxScale={10} >
                                <img
                                  id={`sealedImg-`+ carouselImageType[i]}
                                  alt=""
                                  className={`minH-35px minW-70px`}
                                  src={row[`xx_large_${carouselImageType[i]}_url`]}
                                />
                              </PinchZoomPan>
                            </div>
                          </div>
                        </div>

                      </Carousel.Item>
                    )
                  }
                </Carousel>

              }
            </div>

          :
            <PlaceholderImage
              size={'x_large'}
              additionalClasses={"w-100"}
              hidePlaceHolderText={hidePlaceHolderText}
            />
        }
      </div>

    </Modal.Body>
  </Modal>
};

export default ShowLargeImageModal;